









































































































































































































import { Component, Vue } from "vue-property-decorator";
import OrderRefundModal from "./modals/orderRefundModal.vue";
import Agency from "@/store/entities/agency";
import moment from "moment";

@Component({
  components: { OrderRefundModal },
})
export default class FlightReservationRefund extends Vue {
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  headersWaitingForPayment: any[] = [];
  mockDataWaitingForPayment: any[] = [];
  mockDataDetail: any[] = [];
  headersDetail: any[] = [];
  startDate: Date = null;
  startDateMenu: boolean = false;

  endDate: Date = null;
  endDateMenu: boolean = false;
  breadcrumbsItems: any[] = [];
  active_tab: number = 0;
  checkbox: boolean = false;
  isOpenRow: boolean = false;

  agencies: Agency[] = [];

  get getEndDate() {
    return this.endDate ? moment(this.endDate).format("DD-MM-yyyy") : "";
  }

  get getStartDate() {
    return this.startDate ? moment(this.startDate).format("DD-MM-yyyy") : "";
  }

  created() {
    this.getAgency();

    (this.headers = [
      { text: "Seç", align: "start", filterable: false, value: "open" },
      { text: "", value: "open" },
      { text: "Sipariş No", value: "orderNo" },
      { text: "Müşteri", value: "customer" },
      { text: "İade Tarihi", value: "refundDate" },
      { text: "Geri Ödeme Durumu", value: "refundStatus" },
      { text: "Geri Ödenecek", value: "refundTo" },
      { text: "İade Türü", value: "refundType" },
      { text: "Toplam Ücret", value: "TotalPrice" },
    ]),
      (this.mockData = [
        {
          orderNo: "101728",
          customer: "TEST",
          refundDate: "08-12-2020",
          refundStatus: "Beklemede",
          refundTo: "Acente",
          refundType: "Nakit",
          TotalPrice: "80",
        },
      ]);

    (this.headersDetail = [
      { text: "", align: "start", filterable: false, value: "row" },
      { text: "PNR", value: "pnr" },
      { text: "Uçuş Numarası", value: "flightNo" },
      { text: "Kalkış-Varış", value: "destination" },
      { text: "Sipariş Durumu", value: "orderStatus" },
      { text: "Yolcu Sayısı", value: "PassangerCount" },
    ]),
      (this.mockDataDetail = [
        {
          row: 1,
          pnr: 13665,
          flightNo: "N4 1898",
          destination: "16.03.2021 IST-MCX 18:00",
          orderStatus: "Ödeme alındı",
          PassangerCount: 2,
        },
      ]),
      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Uçuş", disabled: true },
        { text: "Rezervasyon İadeleri", disabled: true },
      ]);
  }

  async getAgency() {
    await this.$store.dispatch({
      type: "agency/getAgency",
    });

    this.agencies = this.$store.state.agency.list;
  }

  openRow() {
    this.isOpenRow = true;
  }
  closeRow() {
    this.isOpenRow = false;
  }

  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
  }

  data() {
    return {
      page: 1,

      // agenciesItems:['ULTRAMARİN','KİLİT GROUP','IATI XML'],
      // agencies: [],
    };
  }
}
